export default "__VITE_ASSET__DCu0KCGC__"